export const CompanySizeEnum = {
    BigFleet: 1,
    SmallBusiness: 2,
    PersonSocial: 3,
    Retail: 4,
    Unknown: -1
};



// WEBPACK FOOTER //
// ./src/enuns/companySize.enum.js